import React, {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Table, Layout, Row, Col, Button, Tag, Divider, Card, Spin} from 'antd'

import { CompanySidebar } from '../../../components/company'
import { logoutUser } from '../../../actions/authActions'
import {LoadingOutlined} from "@ant-design/icons";
import {formatTableDate, getColumnSearchProps, getOrderStateName} from "../../../utils/utility";

import "./style.css"
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import {
  fetchProducerAwaitingConfirmationOrders,
  producerFetchRecentAwaitingChanges
} from "../../../actions/ordersActions";
import history from "../../../utils/history";

export const AwaitingConfirmationPage = (props) => {
  let searchInput = null;

  const user = useSelector(state => state.auth.user)
  const isFetchingProducerAwaitingConfirmationOrders = useSelector(state => state.orders.isFetchingProducerAwaitingConfirmationOrders)
  const awaitingConfirmation = useSelector(state => state.orders.producerAwaitingConfirmation)

  const isFetchingAwaitingChanges = useSelector(state => state.orders.isFetchingAwaitingChanges)
  const awaitingChanges = useSelector(state => state.orders.awaitingChanges)

  const isCollapsed = useSelector(state => state.util.isCollapsed);
  const pagination = useSelector(state => state.orders.producerAwaitingConfirmationPagination)
  const dispatch = useDispatch()

  const [sortedInfo, setSortedInfo] = useState({})
  const [filteredInfo, setFilteredInfo] = useState({})

  const getPageSize = () => {
    const count = Math.floor((window.innerHeight - 450) / 50)
    return count > 6 ? count : 6;
  }

  const pageSize = getPageSize()

  useEffect(() => {
    dispatch(fetchProducerAwaitingConfirmationOrders({
      userId: user.id ,
      sortField: "orderDate",
      sortDirection: "desc",
      orderName: "",
      customerName: "",
      page: pagination.current !== undefined ? pagination.current : 1,
      pagination: {...pagination, pageSize: pageSize}
    }))
    dispatch(producerFetchRecentAwaitingChanges())
  }, []);

  const initializeData = () => {
    setSortedInfo({})
    setFilteredInfo({})
    dispatch(fetchProducerAwaitingConfirmationOrders({
      userId: user.id ,
      sortField: "orderDate",
      sortDirection: "desc",
      orderName: "",
      customerName: "",
      page: 1,
      pagination: {...pagination, current: 1, pageSize: pageSize}
    }))
    dispatch(producerFetchRecentAwaitingChanges())
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...pagination };
    pager.current = pagination.current

    const sortField = sorter.order ? sorter.columnKey : "orderDate"

    const sortDirection = sorter.order ? (sorter.order === "ascend" ? "asc" : "desc") : "desc"
    const orderName = filters.orderName ? filters.orderName[0] : ""
    const customerName = filters.customerName ? filters.customerName[0] : ""

    setFilteredInfo(filters)
    setSortedInfo(sorter)

    dispatch(fetchProducerAwaitingConfirmationOrders({
      userId: user.id,
      sortField: sortField,
      sortDirection: sortDirection,
      orderName: orderName,
      customerName: customerName,
      page: pagination.current,
      pagination: pager
    }))
  }

  const tagColor = (type) => {
    switch (type) {
      case "accepted":
        return "#51b364"
      case "declined":
        return "#b60a1c"
      default:
        return ""
    }
  }

  return (
    <Layout
        style={{
          overflow: 'auto',
          minHeight: '100vh',
        }}
    >
      <CompanySidebar
        onLogout={()=>{dispatch(logoutUser())}}
        user={user}
      />
      <Layout.Content style={{marginLeft: isCollapsed ? 60 : 200, transition: "all 0.25s"}}>
        <div style={{overflowX: "hidden"}}>
          <div style={{marginRight: 25, marginBottom: 15, marginLeft: 25, marginTop: 15}}>
            <Row type="flex">
              <Col span={24}>
                <div style={{display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center"}}>
                  <div style={{display: "flex", alignItems: "flex-start", flexDirection: "column"}}>
                    <div style={{fontWeight: 500, fontSize: 16}}>These are the recent order confirmation changes:</div>
                  </div>
                  <div align={"right"} style={{alignSelf: "flex-end"}}>
                    <Button
                      loading={isFetchingProducerAwaitingConfirmationOrders}
                      style={{fontWeight: 500}}
                      onClick={() => {
                        initializeData()
                      }}
                      type="primary">
                      Check for order changes
                    </Button>
                  </div>
                </div>
                <Divider style={{marginTop: 6, marginBottom: 6}}/>
              </Col>
            </Row>
            <div style={{marginTop: 5, marginBottom: 10}}>
              <Spin
                spinning={isFetchingAwaitingChanges}
                wrapperClassName={"recentChangesSpin"}
                indicator={<LoadingOutlined style={{ fontSize: 48, marginTop: -24, marginLeft: -24 }} spin />}
              >
                <div className={"recentConfirmationsBox"} style={{backgroundColor: "rgba(255,255,255,0.6)"}}>
                  {awaitingChanges.length === 0 ?
                    <div className={"emptyRecentAwaiting"}>
                      {
                        !isFetchingAwaitingChanges &&
                        <div className={"emptyDraftsText"}>No recent Awaiting Orders.</div>
                      }
                    </div>
                    :
                    (awaitingChanges.map(item => (
                      <Card
                        className={"bendCard"}
                        style={{height: 45}}
                        bodyStyle={{padding: "8px 12px 8px 12px", height: "100%", cursor: "pointer"}}
                        key={item.id}
                        onMouseDown={(e) => {
                          if (e.button === 1) {
                            let win;
                            if(item.state === "accepted") {
                              win = window.open(`/accepted-order?order=${item.id}`, "_blank");
                            } else {
                              win = window.open(`/completed-order?order=${item.id}`, "_blank");
                            }
                            win.focus();
                          } else if (e.button === 0) {
                            if(item.state === "accepted") {
                              history.push(`/accepted-order?order=${item.id}`)
                            } else {
                              history.push(`/completed-order?order=${item.id}`)
                            }

                          }
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", height: "100%"}}>
                          <div style={{ display: "flex", height: "100%"}}>
                            <div className={"recentStatusLeft"} style={{width: 140}}>
                              <div>Order {item.name}</div>
                            </div>
                            <div style={{width: 180, fontSize: 13, fontWeight: 500, marginLeft: 10, lineHeight: 2}}>
                              <div>{item.customerName}</div>
                            </div>
                          </div>
                          <div align={"left"} className={"recentStatusLeft"} style={{marginRight: 8}}>
                            <div style={{fontSize: 12, fontWeight: 500}}>Changed: {formatTableDate(item.lastStateChangeDate)}</div>
                          </div>
                          <div style={{ display: "flex", height: "100%", alignItems: "center", alignSelf: "center"}}>
                            <div>
                              <Tag color={"#9966cc"} style={{fontWeight: 500, width: 96, textAlign: "center"}}>Awaiting</Tag>
                            </div>
                            <div style={{marginRight: 8}}>
                              <ArrowRightAltIcon style={{position: "relative", width: 60, top: 3, fontSize: 28, color: "#3f4850"}}/>
                            </div>
                            <div>
                              <Tag color={tagColor(item.state)} style={{fontWeight: 500, width: 96, textAlign: "center"}}>{getOrderStateName(item.state)}</Tag>
                            </div>
                          </div>
                        </div>
                      </Card>
                    )))
                  }
                </div>
              </Spin>
            </div>
            <Row type="flex">
              <Col span={24}>
                <div style={{display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center"}}>
                  <div style={{display: "flex", alignItems: "flex-start", flexDirection: "column"}}>
                    <div style={{fontWeight: 500, fontSize: 16}}>These are your orders that are awaiting confirmation:</div>
                  </div>
                </div>
                <Divider style={{marginTop: 6, marginBottom: 8}}/>
              </Col>
            </Row>
            <Row type="flex">
              <Col span={24}>
                <Fragment>
                  <Table
                    columns={[
                      {
                        title: 'Order Code',
                        key: 'orderName',
                        width: "12%",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {row.orderName}
                          </div>
                        ),
                        filteredValue: filteredInfo.orderName || null,
                        ...getColumnSearchProps('orderName', searchInput, "code"),
                      },
                      {
                        title: 'Order date',
                        key: 'orderDate',
                        className: "darkerColumn",
                        width: "12%",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {formatTableDate(row.orderDate)}
                          </div>
                        ),
                        sorter: true,
                        sortOrder: sortedInfo.columnKey === 'orderDate' && sortedInfo.order
                      },
                      {
                        title: 'Customer',
                        key: 'customerName',
                        width: "19%",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {row.customerName}
                          </div>
                        ),
                        filteredValue: filteredInfo.customerName || null,
                        ...getColumnSearchProps('customerName', searchInput, "customer"),
                      },
                      {
                        title: 'Delivery date',
                        key: 'deliveryDate',
                        className: "darkerColumn",
                        width: "12%",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {formatTableDate(row.deliveryDate)}
                          </div>
                        ),
                        sorter: true,
                        sortOrder: sortedInfo.columnKey === 'deliveryDate' && sortedInfo.order
                      },
                      {
                        title: 'Total with VAT',
                        key: 'totalPriceWithVat',
                        width: "16%",
                        align: "right",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {(row.totalPrice * (1 + row.vatValue) || row.totalPrice || 0).toFixed(2)}€
                          </div>
                        ),
                      },
                      {
                        title: 'Modified',
                        key: 'lastStateChangeDate',
                        className: "darkerColumn",
                        width: "10%",
                        align: "right",
                        render: row => (
                          <div style={{fontWeight: 500, fontSize: 13}}>
                            {formatTableDate(row.lastStateChangeDate || 0)}
                          </div>
                        ),
                        sorter: true,
                        sortOrder: sortedInfo.columnKey === 'lastStateChangeDate' && sortedInfo.order
                      },
                      {
                        title: 'Status',
                        key: 'stateName',
                        width: "200px",
                        align: "center",
                        render: row => (
                          <div>
                            <React.Fragment>
                              <Tag color="#9966cc" style={{fontWeight: 600, textAlign: "center"}}>Awaiting</Tag>
                            </React.Fragment>
                          </div>
                        ),
                      },
                      {
                        title: '',
                        key: 'more',
                        align: "right",
                        render: row => (
                          <Button
                            onMouseDown={(e) => {
                              if (e.button === 1) {
                                const win = window.open(`/awaiting-order?order=${row.id}`, "_blank");
                                win.focus();
                              } else if (e.button === 0) {
                                history.push(`/awaiting-order?order=${row.id}`)
                              }
                            }}
                            type="primary"
                            style={{
                              fontSize: 13,
                              fontWeight: 600
                            }}
                          >
                            Details
                          </Button>
                        ),
                      },
                    ]}
                    className={"awaitingConfirmationOrdersTable"}
                    dataSource={awaitingConfirmation}
                    rowKey="id"
                    pagination={{...pagination, pageSize: pageSize}}
                    loading={{spinning: isFetchingProducerAwaitingConfirmationOrders, indicator: <LoadingOutlined style={{ fontSize: 50,marginLeft: "-25px" }} spin />}}
                    onChange={handleTableChange}
                    size={"small"}
                    scroll={{x: '70%'}}
                  />
                </Fragment>
              </Col>
            </Row>
          </div>
        </div>
      </Layout.Content>
    </Layout>
  )
}
